<template>
  <div>
    <h3 class="mb-15">
      Compétences personnelles
    </h3>
    <div class="flex flex-col space-y-5">
      <div
        v-for="(compPerso, iPerso) in criterions"
        :key="iPerso"
        class="flex flex-col space-y-2.5"
      >
        <div
          class="mr-2 pt-4"
          v-if="iPerso > 0 || criterions.length > 1"
        >
          <delete-button
            @del="deleteCompetence(iPerso)"
            libelle="Supprimer la compétence"
          />
        </div>
        <div
          id="competencesPersoForm"
          class="grid grid-cols-4 gap-4"
        >
          <div class="col-span-full md:col-span-2 lg:col-span-1">
            <input-select
              :name="'categoriesPerso' + iPerso"
              libelle="Catégorie et référentiel"
              :datas="referentiel"
              @input="
                (newValue) => {
                  if (!freezeDatas) getDatas('domaines', iPerso, newValue);
                }
              "
              :value-is-object="true"
              :value="compPerso.values.categories"
            />
          </div>
          <div class="col-span-full md:col-span-2 lg:col-span-1">
            <input-select
              :name="'domainesPerso' + iPerso"
              libelle="Domaine"
              :datas="criterions[iPerso].datas.domaines"
              @input="
                (newValue) => {
                  if (!freezeDatas) getDatas('competences', iPerso, newValue);
                }
              "
              :value="compPerso.values.domaines"
              :value-is-object="true"
            />
          </div>
          <div class="col-span-full md:col-span-2 lg:col-span-1">
            <input-select
              :name="'competencesPerso' + iPerso"
              libelle="Compétences"
              :datas="criterions[iPerso].datas.competences"
              @input="
                (newValue) => {
                  if (!freezeDatas) getDatas('niveaux', iPerso, newValue);
                }
              "
              :value="compPerso.values.competences"
              :value-is-object="true"
            />
          </div>
          <div class="col-span-full md:col-span-2 lg:col-span-1">
            <input-select
              :name="'niveauxPerso' + iPerso"
              libelle="Niveau (minimum)"
              :datas="criterions[iPerso].datas.niveaux"
              @input="
                (newValue) => {
                  if (!freezeDatas) setSearching('niveaux', iPerso, newValue);
                }
              "
              :value="compPerso.values.niveaux"
              :value-is-object="true"
            />
          </div>
        </div>
        <div
          id="tagsCompPerso"
          class="flex flex-wrap space-y-2.5 items-baseline"
        >
          <tag
            v-if="Object.values(compPerso.values.categories).length > 0"
            :libelle="compPerso.values.categories.value"
            theme-color="indigo"
            :is-closeable="true"
            text-size="text-sm"
            text-font="font-light"
            @close="setSearching('categories', iPerso, {})"
            class="mr-2.5"
          />
          <tag
            v-if="Object.values(compPerso.values.domaines).length > 0"
            :libelle="compPerso.values.domaines.value"
            theme-color="pink"
            :is-closeable="true"
            text-size="text-sm"
            text-font="font-light"
            @close="setSearching('domaines', iPerso, {})"
            class="mr-2.5"
          />
          <tag
            v-if="Object.values(compPerso.values.competences).length > 0"
            :libelle="compPerso.values.competences.value"
            theme-color="teal"
            :is-closeable="true"
            text-size="text-sm"
            text-font="font-light"
            @close="setSearching('competences', iPerso, {})"
            class="mr-2.5"
          />
          <tag
            v-if="Object.values(compPerso.values.niveaux).length > 0"
            :libelle="compPerso.values.niveaux.value"
            theme-color="orange"
            :is-closeable="true"
            text-size="text-sm"
            text-font="font-light"
            @close="setSearching('niveaux', iPerso, {})"
            class="mr-2.5"
          />
        </div>
      </div>
      <div id="addCompPersoButton">
        <add-button
          class="hidden sm:flex"
          libelle="Ajouter une compétence personnelle"
          @add="addCompetence"
        />
        <add-button
          class="sm:hidden"
          libelle=""
          @add="addCompetence"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import axios from './../../../api';

import InputSelect from './../../../components/Inputs/InputSelect.vue';
import AddButton from './../../../components/Inputs/AddButton.vue';
import Tag from './../../../components/Tag.vue';
import DeleteButton from './../../../components/Inputs/DeleteButton.vue';

import Constants from './../../../constants';

export default {
  name: 'SearchCompetencesPersonnelles',

  components: {
    InputSelect,
    AddButton,
    Tag,
    DeleteButton,
  },

  props: {
    //
  },

  data() {
    return {
      freezeDatas: false, //When delete a filter, all datas filter are freeze to avoid conflicts
      constants: Constants,
    };
  },

  computed: {
    ...mapGetters({
      referentiels: 'rechercheCompetences/referentiels',
      searching: 'rechercheCompetences/searching',
    }),

    typeCompetence() {
      return Constants.MODULE_NEOPASS_FORM_COMPETENCES_PERSONNELLES;
    },

    referentiel() {
      return this.referentiels[this.typeCompetence];
    },

    criterions() {
      return this.searching[this.typeCompetence];
    },
  },

  methods: {
    ...mapMutations({
      SET_SEARCHING: 'rechercheCompetences/SET_SEARCHING',
    }),

    /**
     * Add an empty competence personnelle filter
     */
    addCompetence() {
      this.searching[this.typeCompetence].push({
        datas: { domaines: [], competences: [], niveaux: [] },
        values: { categories: {}, domaines: {}, competences: [], niveaux: [] },
      });
    },

    /**
     * Delete a competence personnelle filter at "index" position
     * @param Number index
     */
    async deleteCompetence(index) {
      this.freezeDatas = true;
      await this.searching[this.typeCompetence].splice(index, 1);

      setTimeout(() => {
        this.freezeDatas = false;
      }, 500);
    },

    /**
     * According to filter field type, call method to reset next fields
     * @param String typeSearch
     * @param Number index
     * @param Object item
     */
    setSearching(typeSearch, index, item) {
      switch (typeSearch) {
      case 'categories':
        this.setSearchingCategories(index, item);
        break;

      case 'domaines':
        this.setSearchingDomaines(index, item);
        break;

      case 'competences':
        this.setSearchingCompetences(index, item);
        break;

      case 'niveaux':
        this.setSearchingNiveaux(index, item);
        break;

      default:
        break;
      }
    },

    /**
     * When change categorie value, reset all other fields
     * @param Number index
     * @param Object item
     * @param Boolean selfReset
     */
    setSearchingCategories(index, item, selfReset = false) {
      this.searching[this.typeCompetence][index].values.categories = item;

      this.setSearchingDomaines(index, {}, true);
      this.setSearchingCompetences(index, {}, true);
      this.setSearchingNiveaux(index, {}, true);
    },

    /**
     * reset competences and niveaux after choose a domaine, and put empty array value to domaines field
     * @param Number index
     * @param Object item
     * @param Boolean selfReset
     */
    setSearchingDomaines(index, item, selfReset = false) {
      this.searching[this.typeCompetence][index].values.domaines = item;

      if (
        (item === {} ||
          Object.values(item).length === 0 ||
          item.length === 0) &&
        selfReset
      ) {
        this.searching[this.typeCompetence][index].datas.domaines = [];
      }

      this.setSearchingCompetences(index, {}, true);
      this.setSearchingNiveaux(index, {}, true);
    },

    /**
     * reset niveaux after choose a competence, and put empty array value to competence field
     * @param Number index
     * @param Object item
     * @param Boolean selfReset
     */
    setSearchingCompetences(index, item, selfReset = false) {
      this.searching[this.typeCompetence][index].values.competences = item;

      if (
        (item === {} ||
          Object.values(item).length === 0 ||
          item.length === 0) &&
        selfReset
      ) {
        this.searching[this.typeCompetence][index].datas.competences = [];
      }

      this.setSearchingNiveaux(index, {}, true);
    },

    /**
     * put empty array value to niveaux field
     * @param Number index
     * @param Object item
     * @param Boolean selfReset
     */
    setSearchingNiveaux(index, item, selfReset = false) {
      this.searching[this.typeCompetence][index].values.niveaux = item;

      if (
        (item === {} ||
          Object.values(item).length === 0 ||
          item.length === 0) &&
        selfReset
      ) {
        this.searching[this.typeCompetence][index].datas.niveaux = [];
      }
    },

    /**
     * According to filter field type, call method to generate next fields datas
     * @param String typeData
     * @param Number index
     * @param Object item
     */
    getDatas(typeData, index, item) {
      switch (typeData) {
      case 'domaines':
        this.getDomaines(index, item);
        break;

      case 'competences':
        this.getCompetences(index, item);
        break;

      case 'niveaux':
        this.getNiveaux(index, item);
        break;

      default:
        break;
      }
    },

    /**
     * Reset all fields (other than category) and load domaines
     * @param Number index
     * @param Object newCat
     */
    async getDomaines(index, newCat) {
      this.setSearchingCategories(index, newCat);
      if (newCat === '' || Object.values(newCat).length === 0) {
        //Nothing if empty value
        return;
      }

      await axios
        .get('api/recherche/loadDomaines/' + newCat.id)
        .then((response) => {
          this.searching[this.typeCompetence][index].datas.domaines =
            response.data;
        });
    },

    /**
     * Reset all fields before competences (domaine and category) and load competences
     * @param Number index
     * @param Object newCat
     */
    async getCompetences(index, newDom) {
      this.setSearchingDomaines(index, newDom);
      if (newDom === '' || Object.values(newDom).length === 0) {
        //Nothing if empty value
        return;
      }

      await axios
        .get(
          'api/recherche/loadCompetences/' +
            this.searching[this.typeCompetence][index].values.categories.id +
            '/' +
            parseInt(newDom.position)
        )
        .then((response) => {
          this.searching[this.typeCompetence][index].datas.competences =
            response.data;
        });
    },

    /**
     * Reset all fields before niveaux (category, domaine and category) and load Niveaux
     * @param Number index
     * @param Object newCat
     */
    async getNiveaux(index, newComp) {
      this.setSearchingCompetences(index, newComp);
      if (
        newComp === '' ||
        Object.values(newComp).length === 0 ||
        newComp.length === 0
      ) {
        //Nothing if empty value
        return;
      }

      await axios
        .get(
          'api/recherche/loadNiveaux/' +
            this.searching[this.typeCompetence][index].values.categories.id +
            '/' +
            parseInt(
              this.searching[this.typeCompetence][index].values.domaines
                .position
            ) +
            '/' +
            parseInt(newComp.position)
        )
        .then((response) => {
          this.searching[this.typeCompetence][index].datas.niveaux =
            response.data;
        });
    },
  },
};
</script>
